"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddressSearch = void 0;
var _react = require("react");
var _CookiesManager = _interopRequireDefault(require("../../../../utils/CookiesManager"));
var _useAppSelector = require("../../../useAppSelector");
var _productCatalogSelectors = require("../../../../store/productCatalog/productCatalogSelectors");
var _useQuestionSelectionActions = require("../../useQuestionSelectionActions");
var _useAddressSearch = require("../../useAddressSearch");
var _useAppDispatch = require("../../../useAppDispatch");
var _productCatalogActions = require("../../../../store/productCatalog/productCatalogActions");
var _utils = require("../../../../utils/utils");
var _useConfig = _interopRequireDefault(require("../../../useConfig"));
var _lodash = _interopRequireDefault(require("lodash.debounce"));
var _services = require("../../../../services");
var _productCatalogSaga = require("../../../../store/productCatalog/productCatalogSaga");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const retrieveCookieProperties = names => names.map(name => {
  var _CookiesManager$getCo;
  return JSON.parse((_CookiesManager$getCo = _CookiesManager.default.getCookie({
    name,
    encoded: true
  })) !== null && _CookiesManager$getCo !== void 0 ? _CookiesManager$getCo : 'null');
});
const useAddressSearch = (question, selections) => {
  var _split, _cookieAddress$input, _JSON$parse$input, _JSON$parse, _ref, _defaultSelection$add, _ref2, _defaultSelection$str, _ref3, _defaultSelection$str2;
  // ----------------------Hooks and State----------------------
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const debouncedDispatch = (0, _react.useCallback)((0, _lodash.default)(dispatch, 1000), []);
  const cookies = (0, _useConfig.default)('cookies', null);
  const {
    replaceSelection,
    removeSelection
  } = (0, _useQuestionSelectionActions.useQuestionSelectionActions)(question);
  const [cookieAddress] = retrieveCookieProperties(['address']);
  const cookieValues = (_split = cookieAddress === null || cookieAddress === void 0 ? void 0 : (_cookieAddress$input = cookieAddress.input) === null || _cookieAddress$input === void 0 ? void 0 : _cookieAddress$input.split('|')) !== null && _split !== void 0 ? _split : [];
  const cookieInput = {
    address: cookieValues[0] && decodeURIComponent(cookieValues[0]),
    streetName: cookieValues[1] && decodeURIComponent(cookieValues[1]),
    streetNr: cookieValues[2] && decodeURIComponent(cookieValues[2])
  };
  const addressError = (0, _useAppSelector.useAppSelector)(_productCatalogSelectors.selectAddressError);
  const broadbandIds = (0, _useAppSelector.useAppSelector)(_productCatalogSelectors.selectBroadband);
  const selection = (0, _react.useMemo)(() => selections[0], [selections]);
  const defaultSelection = (_JSON$parse$input = (_JSON$parse = JSON.parse(selection !== null && selection !== void 0 ? selection : '{}')) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.input) !== null && _JSON$parse$input !== void 0 ? _JSON$parse$input : {};
  const initialState = {
    address: (_ref = (_defaultSelection$add = defaultSelection.address) !== null && _defaultSelection$add !== void 0 ? _defaultSelection$add : cookieInput === null || cookieInput === void 0 ? void 0 : cookieInput.address) !== null && _ref !== void 0 ? _ref : '',
    streetName: (_ref2 = (_defaultSelection$str = defaultSelection.streetName) !== null && _defaultSelection$str !== void 0 ? _defaultSelection$str : cookieInput === null || cookieInput === void 0 ? void 0 : cookieInput.streetName) !== null && _ref2 !== void 0 ? _ref2 : '',
    streetNr: (_ref3 = (_defaultSelection$str2 = defaultSelection.streetNr) !== null && _defaultSelection$str2 !== void 0 ? _defaultSelection$str2 : cookieInput === null || cookieInput === void 0 ? void 0 : cookieInput.streetNr) !== null && _ref3 !== void 0 ? _ref3 : '',
    addressNotFoundError: false,
    isLoading: false,
    isMultipleAddresses: false,
    invalidInputRule: false
  };
  const {
    addressSuggestions,
    state,
    formDispatch,
    ACTION_TYPES,
    onFieldChange,
    onSuggestionsSelect,
    onFilter
  } = (0, _useAddressSearch.useAddressSearch)(question, initialState, selection);
  const multipleAddressSuggestions = (0, _react.useMemo)(() => {
    const filteredAddressSuggestions = addressSuggestions.map(el => Object.fromEntries(Object.entries(el).filter(_ref4 => {
      let [_, value] = _ref4;
      return value !== null;
    })));
    let locality;
    return filteredAddressSuggestions.map(el => {
      locality = el.locality ? `(${el.locality})` : '';
      return {
        text: `${el.postcode} ${el.city} ${locality} ${el.streetName} ${el.streetNr}`,
        value: JSON.stringify(el)
      };
    });
  }, [addressSuggestions]);
  const specifiedOnFieldChange = (field, value) => {
    var _cookies$address, _cookies$address2;
    _CookiesManager.default.deleteCookie('address', (_cookies$address = cookies.address) === null || _cookies$address === void 0 ? void 0 : _cookies$address.domain, (_cookies$address2 = cookies.address) === null || _cookies$address2 === void 0 ? void 0 : _cookies$address2.path);
    dispatch((0, _productCatalogActions.clearAddresses)());
    dispatch((0, _productCatalogActions.clearAddressError)());
    formDispatch({
      type: ACTION_TYPES.SET,
      payload: {
        key: 'isMultipleAddresses',
        value: false
      }
    });
    formDispatch({
      type: ACTION_TYPES.SET,
      payload: {
        key: 'addressNotFoundError',
        value: false
      }
    });
    onFieldChange(field, value);
  };
  const createSelection = _ref5 => {
    let {
      address,
      streetNr,
      streetName,
      userAddress
    } = _ref5;
    const productOfferingQualificationItem = (0, _productCatalogSaga.getProductOfferingQualificationItem)(broadbandIds);
    const currentAddress = {
      submittedGeographicAddress: {
        id: userAddress.id,
        city: userAddress.city,
        postcode: userAddress.postcode,
        streetName: userAddress.streetName,
        streetNr: userAddress.streetNr,
        geographicSubAddress: userAddress.geographicSubAddress
      },
      productOfferingQualificationItem
    };
    dispatch((0, _productCatalogActions.setSelectedAddress)(currentAddress));
    return JSON.stringify({
      ...currentAddress
    });
  };

  // ----------------------Handler-----------------------------------

  const handleInputStringCreation = (address, streetName, streetNr) => {
    return [encodeURIComponent((0, _utils.capitalize)(address.trim().toLowerCase())), encodeURIComponent(streetName.trim()), encodeURIComponent(streetNr.trim())].join('|').trim();
  };
  const checkIsGermanPostcode = text => {
    const germanPostcodeRegex = /^\d{5}$/; // 5 digits
    return germanPostcodeRegex.test(text);
  };
  const handleFetchAddressSuggestions = (0, _react.useCallback)(() => {
    const isAddressGermanPostcode = checkIsGermanPostcode(state.address);
    const payload = {
      city: !isAddressGermanPostcode ? state.address : '',
      streetName: state.streetName,
      streetNr: state.streetNr,
      postcode: isAddressGermanPostcode ? state.address : ''
    };
    debouncedDispatch((0, _productCatalogActions.fetchAddressSuggestions)(payload, cookies), {});
  }, [state, dispatch, cookies]);
  const handleInvalidInputRule = value => {
    if (state.invalidInputRule === value) return;
    formDispatch({
      type: ACTION_TYPES.SET,
      payload: {
        key: 'invalidInputRule',
        value: value
      }
    });
  };
  const handleMultipleAddressSelection = value => {
    var _cookies$address3, _cookies$address4, _userAddress$geograph, _userAddress$geograph2;
    const userAddress = JSON.parse(value);
    _CookiesManager.default.setCookie({
      name: 'address',
      value: JSON.stringify({
        ..._services.Services.Parsers.CookieParser.mapCookie(userAddress),
        input: handleInputStringCreation(userAddress.city, userAddress.streetName, userAddress === null || userAddress === void 0 ? void 0 : userAddress.streetNr)
      }),
      encoded: true,
      domain: cookies === null || cookies === void 0 ? void 0 : (_cookies$address3 = cookies.address) === null || _cookies$address3 === void 0 ? void 0 : _cookies$address3.domain,
      path: cookies === null || cookies === void 0 ? void 0 : (_cookies$address4 = cookies.address) === null || _cookies$address4 === void 0 ? void 0 : _cookies$address4.path
    });
    const addressInput = `${userAddress.postcode} ${userAddress.city}`;
    formDispatch({
      type: ACTION_TYPES.INJECT,
      payload: {
        ...userAddress,
        address: addressInput
      }
    });
    replaceSelection(createSelection({
      address: userAddress === null || userAddress === void 0 ? void 0 : userAddress.city,
      streetName: userAddress === null || userAddress === void 0 ? void 0 : userAddress.streetName,
      streetNr: userAddress === null || userAddress === void 0 ? void 0 : (_userAddress$geograph = userAddress.geographicSubAddress) === null || _userAddress$geograph === void 0 ? void 0 : (_userAddress$geograph2 = _userAddress$geograph[0]) === null || _userAddress$geograph2 === void 0 ? void 0 : _userAddress$geograph2.subUnitNumber,
      userAddress
    }));
  };

  // --------------------------Effects-----------------------------------

  (0, _react.useEffect)(() => {
    var _state$address, _state$streetName, _addressSuggestions$;
    //This effect handles the assignment of the selection based on the address suggestions
    const isCompleteAddress = ((_state$address = state.address) === null || _state$address === void 0 ? void 0 : _state$address.length) >= 2 && ((_state$streetName = state.streetName) === null || _state$streetName === void 0 ? void 0 : _state$streetName.length) >= 2 && state.streetNr;
    const userAddress = (_addressSuggestions$ = addressSuggestions[0]) !== null && _addressSuggestions$ !== void 0 ? _addressSuggestions$ : {};
    if (addressSuggestions.length && isCompleteAddress) {
      if (!state.isMultipleAddresses && addressSuggestions.length > 1) {
        formDispatch({
          type: ACTION_TYPES.SET,
          payload: {
            key: 'isMultipleAddresses',
            value: true
          }
        });
        handleMultipleAddressSelection(JSON.stringify(userAddress));
      } else {
        replaceSelection(createSelection({
          address: state.address,
          streetName: state.streetName,
          streetNr: state.streetNr,
          userAddress
        }));
      }
      formDispatch({
        type: ACTION_TYPES.SET,
        payload: {
          key: 'addressNotFoundError',
          value: false
        }
      });
      formDispatch({
        type: ACTION_TYPES.SET,
        payload: {
          key: 'isLoading',
          value: false
        }
      });
    }
  }, [addressSuggestions, state.address, state.streetName, state.streetNr]);
  (0, _react.useEffect)(() => {
    var _state$address2, _state$streetName2;
    //This effect handles the dispatch of the fetch addressSuggestions action
    const isCompleteAddress = ((_state$address2 = state.address) === null || _state$address2 === void 0 ? void 0 : _state$address2.length) >= 2 && ((_state$streetName2 = state.streetName) === null || _state$streetName2 === void 0 ? void 0 : _state$streetName2.length) >= 2 && state.streetNr;
    if (!isCompleteAddress || state.invalidInputRule || state.isMultipleAddresses || selection) {
      debouncedDispatch.cancel();
      return;
    }
    formDispatch({
      type: ACTION_TYPES.SET,
      payload: {
        key: 'isLoading',
        value: true
      }
    });
    handleFetchAddressSuggestions();
    return () => {
      formDispatch({
        type: ACTION_TYPES.SET,
        payload: {
          key: 'isLoading',
          value: false
        }
      });
    };
  }, [state.address, state.streetName, state.streetNr, state.invalidInputRule, state.isMultipleAddresses]);
  (0, _react.useEffect)(() => {
    //This effect handles the removal of the selection if the address is not found
    const isEmptyAddress = !state.address && !state.streetName && !state.streetNr;
    if (addressError && !isEmptyAddress) {
      removeSelection(selection);
      formDispatch({
        type: ACTION_TYPES.SET,
        payload: {
          key: 'addressNotFoundError',
          value: true
        }
      });
      formDispatch({
        type: ACTION_TYPES.SET,
        payload: {
          key: 'isMultipleAddresses',
          value: false
        }
      });
      formDispatch({
        type: ACTION_TYPES.SET,
        payload: {
          key: 'isLoading',
          value: false
        }
      });
    } else if (addressError) {
      formDispatch({
        type: ACTION_TYPES.SET,
        payload: {
          key: 'addressNotFoundError',
          value: false
        }
      });
      formDispatch({
        type: ACTION_TYPES.SET,
        payload: {
          key: 'isLoading',
          value: false
        }
      });
    }
  }, [addressError, state.address, state.streetName, state.streetNr, selection]);
  (0, _react.useEffect)(() => {
    //This effect handles the clearing of any error messages when the form is empty

    if (!(state.address || state.streetName || state.streetNr) && addressError) {
      dispatch((0, _productCatalogActions.clearAddressError)());
    }
  }, [state, addressError, dispatch, _productCatalogActions.clearAddressError]);

  // -------------------------------------------------------------------

  return {
    state: state,
    onFieldChange: specifiedOnFieldChange,
    onSuggestionsSelect,
    addressSuggestions,
    onFilter,
    handleFetchAddressSuggestions,
    handleInvalidInputRule,
    multipleAddressSuggestions,
    handleMultipleAddressSelection,
    checkIsGermanPostcode
  };
};
exports.useAddressSearch = useAddressSearch;